/* Auriani v7 (step 3): small enhancements for content pages, search and contact.
   Every feature works without this file (plain text, all options, real links); it only adds
   convenience. */
(() => {
  'use strict';
  if (window.__auPagesReady) return;
  window.__auPagesReady = true;

  /* Shipping: estimated arrival dates from today, skipping weekends ("5-11" business days). */
  const addBusinessDays = (from, days) => {
    const d = new Date(from);
    let left = days;
    while (left > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) left--; }
    return d;
  };
  const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  document.querySelectorAll('[data-au-eta]').forEach(node => {
    const [min, max] = node.dataset.auEta.split('-').map(Number);
    if (!min || !max) return;
    const today = new Date();
    node.textContent = `${fmt.format(addBusinessDays(today, min))} – ${fmt.format(addBusinessDays(today, max))}`;
    const note = document.createElement('small');
    note.textContent = `${min}–${max} business days if you order today`;
    node.after(note);
  });

  /* FAQ: filter the questions as you type. */
  const faqField = document.querySelector('[data-au-faq-filter] input');
  if (faqField) {
    const empty = document.querySelector('[data-au-faq-empty]');
    faqField.addEventListener('input', () => {
      const q = faqField.value.trim().toLowerCase();
      let shown = 0;
      document.querySelectorAll('[data-au-faq-group]').forEach(group => {
        let inGroup = 0;
        group.querySelectorAll('details').forEach(item => {
          const hit = !q || item.textContent.toLowerCase().includes(q);
          item.hidden = !hit;
          if (q && hit) item.open = true;
          if (hit) inGroup++;
        });
        group.hidden = inGroup === 0;
        shown += inGroup;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }

  /* Contact: the sub-topic list follows the topic; the full name goes into contact[name]. */
  document.querySelectorAll('[data-au-contact]').forEach(form => {
    const topic = form.querySelector('[data-au-topic]');
    const sub = form.querySelector('[data-au-subtopic]');
    if (topic && sub) {
      const groups = Array.from(sub.querySelectorAll('optgroup'));
      const sync = () => {
        groups.forEach(group => {
          const on = !topic.value || group.label === topic.value;
          group.hidden = !on; group.disabled = !on;
        });
        const current = sub.selectedOptions[0];
        if (current && current.parentElement.tagName === 'OPTGROUP' && current.parentElement.disabled) sub.value = '';
      };
      topic.addEventListener('change', sync);
      sync();
    }
    form.addEventListener('submit', () => {
      const first = form.querySelector('[name="contact[first_name]"]')?.value.trim() || '';
      const last = form.querySelector('[name="contact[last_name]"]')?.value.trim() || '';
      const full = form.querySelector('[data-au-fullname]');
      if (full) full.value = `${first} ${last}`.trim();
    });
    const ok = form.querySelector('.au-pg-form__ok');
    if (ok) ok.focus();
  });

  /* Search: "Load more" appends the next page in place; the link stays a real, crawlable link. */
  document.addEventListener('click', async event => {
    const more = event.target.closest('[data-au-search-more]');
    if (!more || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    const grid = document.querySelector('[data-au-search-grid]');
    if (!grid) return;
    event.preventDefault();
    more.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(more.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.querySelector('[data-au-search-grid]');
      const firstNew = nextGrid?.firstElementChild;
      nextGrid && Array.from(nextGrid.children).forEach(card => grid.append(card));
      const wrap = document.querySelector('[data-au-search-more-wrap]');
      const nextWrap = doc.querySelector('[data-au-search-more-wrap]');
      if (wrap && nextWrap) wrap.replaceWith(nextWrap); else wrap?.remove();
      history.replaceState(history.state, '', more.href);
      firstNew?.querySelector('a')?.focus({ preventScroll: true });
    } catch (_) {
      window.location.assign(more.href);
    }
  });
})();
